import { render } from "./message-templates.vue?vue&type=template&id=229e38b3&scoped=true"
import script from "./message-templates.vue?vue&type=script&lang=js"
export * from "./message-templates.vue?vue&type=script&lang=js"

import "./message-templates.vue?vue&type=style&index=0&id=229e38b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229e38b3"]])

export default __exports__